import {
  SET_SIGN_UP_OPEN,
  SET_SIGN_UP_CLOSE,
  SET_SIGN_IN_CLOSE,
  SET_SIGN_IN_OPEN,
  SET_RESET_PASSWORD_CLOSE,
  SET_RESET_PASSWORD_OPEN,
  SET_ONBOARDING_COMPONENT_EXP_VARIATION,
  SET_ONBOARDING_COMPONENT_EXP_LOADED,
} from '@data/constants/actionTypes/onboardingComponent';

export const setOnboardingComponentSignUpOpen = context => ({
  type: SET_SIGN_UP_OPEN,
  context,
});

export const setOnboardingComponentSignUpClose = () => ({
  type: SET_SIGN_UP_CLOSE,
});

export const setOnboardingComponentSignInOpen = context => ({
  type: SET_SIGN_IN_OPEN,
  context,
});

export const setOnboardingComponentSignInClose = () => ({
  type: SET_SIGN_IN_CLOSE,
});

export const setOnboardingComponentResetPasswordOpen = () => ({
  type: SET_RESET_PASSWORD_OPEN,
});

export const setOnboardingComponentResetPasswordClose = () => ({
  type: SET_RESET_PASSWORD_CLOSE,
});

export const setOnboardingComponentExperimentVariation = (value) => ({
  type: SET_ONBOARDING_COMPONENT_EXP_VARIATION,
  value,
});

export const setOnboardingComponentExperimentLoaded = () => ({
  type: SET_ONBOARDING_COMPONENT_EXP_LOADED,
});
